<template>
  <div>
    <v-dialog scrollable max-width="1200px" v-model="model" persistent>
      <material-card
        :title="$t('components.invoices.invoice_view_dialog.title')"
        :color="$vuetify.theme.themes.light.primary"
        icon="visibility"
      >
        <v-card-text v-html="invoice" />
        <v-card-actions>
          <v-btn text @click="$emit('close')" :loading="loading">
            {{ $t("globals.close") }}
          </v-btn>
          <v-btn color="primary" @click="print" :loading="loading">
            {{ $t("globals.print") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <error-handler :error="error"></error-handler>
    <v-dialog scrollable v-model="loading" persistent max-width="200">
      <v-card>
        <v-card-title>{{ $t("globals.please_wait") }}</v-card-title>
        <v-card-text>
          <v-container fluid grid-list-md>
            <v-layout row justify-center>
              <v-flex xs12 sm6 md4 lg3>
                <v-progress-circular indeterminate></v-progress-circular>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <iframe name="print_frame" width="0" height="0" frameborder="0" src="about:blank"></iframe>
  </div>
</template>

<script>
import ErrorHandler from "@/components/ErrorHandler.vue";
import { mapActions } from "vuex";
export default {
  props: ["model", "id"],
  components: {
    ErrorHandler,
  },
  data() {
    return {
      error: null,
      invoice: null,
      loading: false,
    };
  },

  watch: {
    model: {
      handler(v) {
        if (v) {
          this.loadData();
        }
      },
    },
  },
  mounted() {
    this.loadData();
  },
  methods: {
    ...mapActions("plansMembers", ["getInvoiceById"]),
    async loadData() {
      //TODO: fix this.invoice to get data from the correct property of the json response
      try {
        this.loading = true;
        this.invoice = (await this.getInvoiceById({
          id: this.id,
        })).data;
      } catch (error) {
        this.error = error;
      } finally {
        this.loading = false;
      }
    },
    print() {
      window.frames["print_frame"].document.body.innerHTML = this.invoice;
      window.frames["print_frame"].window.focus();
      window.frames["print_frame"].window.print();
    },
  },
};
</script>
